import { MultilingualWidgetConfig } from '../dashboard.widgets.config';

interface XRayData {
  patientName: {
    en: string;
    de: string;
  };
  imageSrc: string;
  imageAlt: {
    en: string;
    de: string;
  };
  clickPrompt: {
    en: string;
    de: string;
  };
}

const xrayData: XRayData = {
  patientName: {
    en: 'James Rodriguez',
    de: 'James Schneider',
  },
  imageSrc: 'https://medlineplus.gov/images/Xray_share.jpg',
  imageAlt: {
    en: 'Chest X-Ray',
    de: 'Thorax-Röntgen',
  },
  clickPrompt: {
    en: 'Click to enlarge or upload new image',
    de: 'Klicken Sie zum Vergrößern oder zum Hochladen eines neuen Bildes',
  },
};

const generateXRayHtml = (language: 'en' | 'de'): string => {
  const header = language === 'en' ? 'Chest X-Ray' : 'Thorax-Röntgen';

  return `
    <div style="display: flex; flex-direction: column; height: 100%; align-items: center; justify-content: center; text-align: center; background-color: #282a32; color: white; padding: 16px; border-radius: 8px;">
      <div style="font-weight: 600; margin-bottom: 12px;">${header}: ${xrayData.patientName[language]}</div>
      <div style="width: 100%; height: 80%; display: flex; justify-content: center; align-items: center; background-color: #1f2224; border-radius: 8px; position: relative; overflow: hidden;">
        <img src="${xrayData.imageSrc}" alt="${xrayData.imageAlt[language]}" style="max-width: 100%; max-height: 100%; object-fit: contain; border-radius: 8px;" />
      </div>
      <div style="font-size: 0.85rem; margin-top: 12px; color: #e9ecf4;">${xrayData.clickPrompt[language]}</div>
    </div>`;
};

export const xrayViewerWidget: MultilingualWidgetConfig = {
  id: 'xray-widget',
  translations: {
    en: {
      title: 'X-Ray Viewer',
      content: generateXRayHtml('en'),
    },
    de: {
      title: 'Röntgenbild-Betrachter',
      content: generateXRayHtml('de'),
    },
  },
  x: 0,
  y: 2,
  w: 2,
  h: 5,
};
